import React, 
     { useState , 
       useEffect,
       useRef , }        from 'react'
import Grid              from '@mui/material/Grid'
import Box               from '@mui/material/Box'
import Typography        from '@mui/material/Typography'
import Paper             from '@mui/material/Paper'
import TextField         from '@mui/material/TextField'
import Dialog            from '@mui/material/Dialog'
import DialogActions     from '@mui/material/DialogActions'
import DialogContent     from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle       from '@mui/material/DialogTitle'
import Button            from '@mui/material/Button'
import axios             from 'axios'
import store             from '../../store'
import '../../App.css'
import '../../style.css';

// --------------------定数---------------------
export const baseId  = "molecule-game-boy-logo"
const GameMusic      = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F21%20%E3%83%9E%E3%82%B5%E3%82%AD%E3%81%AE%E3%82%82%E3%81%A8%E3%81%B8%EF%BC%8D%E3%83%8F%E3%83%8A%E3%82%BF%E3%82%99%E3%82%88%E3%82%8A.wav?alt=media&token=77399b16-4558-4b95-ac73-c458c8ae3a52"
const getImage       = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/SITE_IMG%2F01_MAINPAGE%2F%E3%83%A2%E3%83%B3%E3%82%B9%E3%82%BF%E3%83%BC%E3%83%9C%E3%83%BC%E3%83%AB.png?alt=media&token=2ddd598b-024e-4483-86e7-031fd66b9454"
const PokemonBatle   = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F07%20%E6%88%A6%E3%81%84%EF%BC%88%EF%BC%B6%EF%BC%B3%E9%87%8E%E7%94%9F%E3%83%9B%E3%82%9A%E3%82%B1%E3%83%A2%E3%83%B3%EF%BC%89.wav?alt=media&token=8dacd0f2-c1ee-4394-85e3-0eaca290ea15"
const PokemonVictory = "https://firebasestorage.googleapis.com/v0/b/simpletypinggame.appspot.com/o/MUSIC%2F08%20%E5%8B%9D%E5%88%A9%EF%BC%88%EF%BC%B6%EF%BC%B3%E9%87%8E%E7%94%9F%E3%83%9B%E3%82%9A%E3%82%B1%E3%83%A2%E3%83%B3%EF%BC%89.wav?alt=media&token=d757071f-c712-42fa-8644-e4022c809b60"

function GameMain() {
  const [pokemonImage   , setPokemonImage   ] = useState(getImage) // ポケモン画像表示
  const [pokemonname    , setPokemonName    ] = useState()         // ポケモンの名前
  const [showRadioGroup , setShowRadioGroup ] = useState(true)     // ラジオグループの表示コントロール
  const [frontNum       , setFrontNum       ] = useState(0)        // かける数を代入
  const [backNum        , setBackNum        ] = useState(0)        // かけられる数を代入
  const [value          , setValue          ] = useState()         // 答えのテキストボックスに入力している値
  const [resultWord     , setResultWord     ] = useState()         // 正解 or 不正解の判定
  const [fontColor      , setFontColor      ] = useState()         // フォントカラー
  const [count          , setCount          ] = useState(1)        // 問題数
  const [dialogopen     , setDialogOpen     ] = useState(false)    // ダイアログ表示の状態管理
  const [correctCount   , setCorrectCount   ] = useState(0)        // 正解の数
  const [getPokemonList , setGetPokemonList ] = useState([])       // 正解したポケモンの画像を格納する配列

  var useEffectCount = 0  // useEffectのカウンタ
  // 音楽が流れる
  const [gameMusic]       = useState(new Audio(GameMusic))
  const [battleAudio]     = useState(new Audio(PokemonBatle))
  const [pokemonVictory ] = useState(new Audio(PokemonVictory))

  useEffect(() => {
    console.log("選択中のゲームモード=>",store.getState().GameModeSelect)
    console.log("選択中の計算式:",store.getState().CalcSelect)
    
    // 1秒待機する
    setTimeout(() => {
      console.log("★" , useEffectCount);
      useEffectCount = useEffectCount+1
      // useEffectが2回呼び出される？ため、２回目のみ処理を起動する
      if(useEffectCount === 1){
        startPokemonBatlePlay()  // 再生
        // ポケモンを呼び出す
        fetchPokemonImages()
        // 前項の取得
        let front = Math.floor(Math.random() * 10) + 1
        // 後項の取得
        let back = Math.floor(Math.random() * 9) + 1
        
        // 前項が後項以下の場合、前項が後項よりも大きくなるまで再試行する
        while (front <= back) {
          front = Math.floor(Math.random() * 10) + 1
          console.log("front:" , front)
          console.log("back:" , back)
          console.log("--------------")
        }
        
        setFrontNum(front)
        setBackNum(back)
        }

    }, 1000) // 500ミリ秒 = 0.5秒待機

  }, [])

  // ポケモンAPIを呼び出す
  const fetchPokemonImages = async () => {
    // ポケモンAPIを呼び出す
    // No.151までを取得
    console.log("PokemonAPI")
    const randomNumber = Math.floor(Math.random() * 1010) + 1
    // ポケモンAPIを呼び出す
    const response = await axios.get("https://pokeapi.co/api/v2/pokemon/" + randomNumber)
    const speciesUrl = response.data.species.url
    const speciesResponse = await axios.get(speciesUrl)
    // ポケモンの画像を取得
    setPokemonImage(response.data.sprites.front_default)

    // ポケモンの名前を取得
    const japaneseName = speciesResponse.data.names.find(name => name.language.name === "ja").name
    setPokemonName(japaneseName)
    console.log(pokemonname)
  }

  // バトル音楽を再生
  const startPokemonBatlePlay = () => {
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    battleAudio.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      battleAudio.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // 勝利音楽を再生
  const startPokemonVictoryPlay = () => {
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
    pokemonVictory.currentTime = 0 // 常に先頭から再生
    // 1秒待機する
    setTimeout(() => {
      pokemonVictory.play() // 再生
    }, 500) // 500ミリ秒 = 0.5秒待機
  }

  // 音楽をすべて停止
  const AllMusicPause = () => {
    gameMusic.pause()       // 停止
    battleAudio.pause()     // 停止
    pokemonVictory.pause()  // 停止
  }

  // 初期値に戻す
  const initialize = () => {
    setShowRadioGroup(true)
    setPokemonImage("")
    setPokemonName("")
    setCount(1)
    setFontColor("")
    setResultWord("")
    setValue("")
    setCorrectCount(0)
    setGetPokemonList([])
  }
  
  // ダイアログを開く
  const handleDialogOpen = () => {
    setDialogOpen(true)

    startPokemonVictoryPlay() // 再生
  }

  // ダイアログを閉じる
  // もう一度ゲームをやる
  const handleGameReturn = () => {
    setDialogOpen(false)
    // 初期状態に戻す
    initialize(true)

    startPokemonBatlePlay()  // 再生
    // ポケモンを呼び出す
    fetchPokemonImages()
    // 前項の取得
    let front = Math.floor(Math.random() * 10) + 1
    // 後項の取得
    let back = Math.floor(Math.random() * 9) + 1
    
    // 前項が後項以下の場合、前項が後項よりも大きくなるまで再試行する
    while (front <= back) {
      front = Math.floor(Math.random() * 10) + 1
      console.log("front:" , front)
      console.log("back:" , back)
      console.log("--------------")
    }
    
    setFrontNum(front)
    setBackNum(back)
  }

  // ダイアログを閉じる
  // リフレッシュする
  const handleGameReflesh = () => {
    setDialogOpen(false)
    // 初期状態に戻す
    initialize(true)

    window.location.reload() // 画面をリフレッシュする
  }

  // テキストボックスの内容
  const handleChange = (event) => {
    // 入力された値が数字でない場合は削除します
    const inputValue = event.target.value.replace(/[^0-9]/g, '')
    setValue(inputValue)
  }

  // 答えが入力された時の処理
  const handleKeyPressResult = (event) => {
    const BuffAry = []
    if (event.key === 'Enter') {
      console.log("入力値 => ",event.target.value)

      switch (store.getState().CalcSelect) {
        case 'tashi':
          if (event.target.value == frontNum + backNum) {
            console.log("正解")
            setResultWord("せいかい！GET！！")  // 結果のメッセージ
            setFontColor("red")                // フォントカラー設定

            // 配列に加える
            setGetPokemonList(prevList => {
              const newList = [...prevList, pokemonImage];
              console.log("getPokemonList : ", newList, newList.length)
              return newList
            })

            setCorrectCount(correctCount + 1)    // 正解数を増加
            setPokemonImage(getImage)          // 画像をモンスターボールに変更
          } else {
            console.log("不正解")
            setFontColor("blue")              // フォントカラー設定
            setResultWord("にげられた。。。")  // 結果メッセージ
          }
          break

        case 'hiki':
          if (event.target.value == frontNum - backNum) {
            console.log("正解")
            setResultWord("せいかい！GET！！")  // 結果のメッセージ
            setFontColor("red")                // フォントカラー設定

            // 配列に加える
            setGetPokemonList(prevList => {
              const newList = [...prevList, pokemonImage]
              console.log("getPokemonList : ", newList, newList.length)
              return newList
            });

            setCorrectCount(correctCount + 1)    // 正解数を増加
            setPokemonImage(getImage)          // 画像をモンスターボールに変更
          } else {
            console.log("不正解")
            setFontColor("blue")              // フォントカラー設定
            setResultWord("にげられた。。。")  // 結果メッセージ
          }
          break

        case 'kake':
        if (event.target.value == frontNum * backNum) {
          console.log("正解")
          setResultWord("せいかい！GET！！")  // 結果のメッセージ
          setFontColor("red")                // フォントカラー設定

          // 配列に加える
          setGetPokemonList(prevList => {
            const newList = [...prevList, pokemonImage]
            console.log("getPokemonList : ", newList, newList.length)
            return newList
          })

          setCorrectCount(correctCount + 1)    // 正解数を増加
          setPokemonImage(getImage)          // 画像をモンスターボールに変更
        } else {
          console.log("不正解")
          setFontColor("blue")              // フォントカラー設定
          setResultWord("にげられた。。。")  // 結果メッセージ
        }
        break

        default:
          break
      }
      
      // カウントアップ
      setCount(count+1)
      console.log("count => " , count)
      // 10問で終了、終了後は処置期画面へ
      if(count == 10){

      // 2秒待機する
      setTimeout(() => {
        console.log("終了")

        // ダイアログを表示する
        handleDialogOpen(true)

      }, 2000); // 2000ミリ秒 = 2秒待機

      }else{
        // ポケモンを再取得
        fetchPokemonImages()

        // 2秒待機する
        setTimeout(() => {

          setResultWord("")
          setValue("")

          // 前項の取得
          let front = Math.floor(Math.random() * 10) + 1
          // 後項の取得
          let back = Math.floor(Math.random() * 9) + 1
          
          // 前項が後項以下の場合、前項が後項よりも大きくなるまで再試行する
          while (front <= back) {
            front = Math.floor(Math.random() * 10) + 1
            console.log("front:" , front)
            console.log("back:" , back)
            console.log("--------------")
          }
          
          setFrontNum(front)
          setBackNum(back)

        }, 1000) // 2000ミリ秒 = 2秒待機
      }
    }
  }

  // エンターキーが押された時の処理
  const handleKeyPress = (event) => {
    // yes or no を選択
    console.log(event.target.value)
    
    // Enterキーが押された時は非表示にする
    if (event.key === 'Enter') {
      // yes or no の判定
      if(event.target.value == "yes"){
        console.log("yesが選択された！")

        // ポケモンAPIを呼び出す
        fetchPokemonImages()

        // 前項の取得
        let front = Math.floor(Math.random() * 10) + 1
        // 後項の取得
        let back = Math.floor(Math.random() * 9) + 1
        
        // 前項が後項以下の場合、前項が後項よりも大きくなるまで再試行する
        while (front <= back) {
          front = Math.floor(Math.random() * 10) + 1
          console.log("front:" , front)
          console.log("back:" , back)
          console.log("--------------")
        }
        
        setFrontNum(front)
        setBackNum(back)

        // ラジオボタン表示を消す
        setShowRadioGroup(false)
      }else{
        console.log("noが選択された！")
        // 画面をリフレッシュする
        window.location.reload() // 画面をリフレッシュする
      }
    }

  }

  return (
      <Box sx={{ m : 1 , p : 4}}>
        {/* 画面 */}
        <Paper sx={{ m: 1, p: 1 ,
                bgcolor      : '#f5f5dc'  ,
                borderRadius : "1px"      , 
                height       : "250px"    ,
                width        : '250px'    ,
                position     : 'absolute' , // 絶対位置指定
                top          : '20px'     , // 縦位置を50pxに指定
                left         : '40px'     , // 横位置を20pxに指定
        }}>
            <Grid container spacing={0}>

              {/* ダイアログ表示 */}
              <Dialog
                open={dialogopen}
                onClose={handleGameReturn}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description">
                <DialogTitle id="alert-dialog-title">
                  <Grid container spacing={2}>
                    <Grid item xs={1} align="right">
                      <img
                          src    = {getImage}
                          width  = "50px"
                          height = "50px"/>
                    </Grid>
                    <Grid item xs={10} align="center">
                      <Typography
                        sx={{
                        // 独自フォントに設定
                        fontFamily   : 'DotGothic16'   , // Kalamフォント
                        fontSize     : "25px"    , 
                        color        : '#000000' , // フォントの色を黒に設定
                        }}>うまく入力できたかな？
                      </Typography>
                    </Grid>
                    <Grid item xs={1} align="left">
                      <img
                        src    = {getImage}
                        width  = "50px"
                        height = "50px"/>
                    </Grid>
                  </Grid>
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description">
                    <Grid container spacing={2}>
                      <Grid item xs={12} align="center">
                        <Typography
                          sx={{
                          // 独自フォントに設定
                          fontFamily   : 'DotGothic16'   , // Kalamフォント
                          fontSize     : "16px"    , 
                          color        : '#000000' , // フォントの色を黒に設定
                          }}>正しく入力できたかず
                        </Typography>
                      </Grid>
                      <Grid item xs={12} align="center">
                        <Typography
                          sx={{
                          // 独自フォントに設定
                          fontFamily   : 'DotGothic16'   , // Kalamフォント
                          fontSize     : "27px"    , 
                          color        : '#000000' , // フォントの色を黒に設定
                          }}>{correctCount} もん
                        </Typography>
                      </Grid>
                      <Grid item xs={12} align="center">
                      <Typography
                          sx={{
                          // 独自フォントに設定
                          fontFamily   : 'DotGothic16'   , // Kalamフォント
                          fontSize     : "16px"    , 
                          color        : '#000000' , // フォントの色を黒に設定
                          }}>↓↓↓↓↓ゲットしたポケモン↓↓↓↓↓</Typography>
                      </Grid>
                      {/* ポケモン画像表示 */}
                      {getPokemonList.map((getPokemonList , index) => (
                        <Grid item xs = {3} align="center">
                          <Button>
                            <img
                              key    = {index}
                              src    = {getPokemonList}
                              width  = "130px"
                              />
                          </Button>
                          {/* ポケモンの名前 */}
                          {/* {pokemonnames[index]} */}
                        </Grid>
                      ))}
                    </Grid>
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={handleGameReflesh}>
                    はじめのがめん
                  </Button>
                  <Button 
                    onClick={handleGameReturn} 
                    variant='contained'>
                    もういちど
                  </Button>
                </DialogActions>
              </Dialog>

                {/* タイトル表示 */}
                <Grid item xs={12} align="center">
                  <Typography
                      sx={{
                      // 独自フォントに設定
                      fontFamily   : 'DotGothic16'   , // Kalamフォント
                      fontSize     : "27px"    , 
                      color        : '#000000' , // フォントの色を黒に設定
                      }}>けいさんもんだい</Typography>
                </Grid>

                {/* ポケモン表示 */}
                <Grid item xs={12} align="center">
                    <img
                    src    = {pokemonImage}
                    width  = "100px"
                    height = "100px"/>
                </Grid>

                {/* 計算問題 表示 */}
                {/* 前項の表示 */}
                  <Grid item xs={2} align="center">
                    <Typography
                      sx={{
                        // 独自フォントに設定
                        fontFamily   : 'DotGothic16'   , // フォント
                        fontSize     : "25px"          , 
                        color        : '#000000'       , // フォントの色を黒に設定
                        }}>{frontNum}</Typography>
                  </Grid>
                  <Grid item xs={2} align="center">
                    <Typography
                      sx={{
                        // 独自フォントに設定
                        fontFamily   : 'DotGothic16'   , // フォント
                        fontSize     : "25px"          , 
                        color        : '#000000'       , // フォントの色を黒に設定
                        }}>
                          {store.getState().CalcSelect === 'tashi' ? ' ＋ ' 
                          : store.getState().CalcSelect === 'hiki' ? ' - ' 
                          : ' × '}</Typography>
                  </Grid>
                {/* 後項の表示 */}
                  <Grid item xs={2} align="center">
                    <Typography
                      sx={{
                        // 独自フォントに設定
                        fontFamily   : 'DotGothic16'   , // フォント
                        fontSize     : "25px"          , 
                        color        : '#000000'       , // フォントの色を黒に設定
                        }}>{backNum}</Typography>
                  </Grid>
                  <Grid item xs={2} align="center">
                    <Typography
                      sx={{
                        // 独自フォントに設定
                        fontFamily   : 'DotGothic16'   , // フォント
                        fontSize     : "25px"          , 
                        color        : '#000000'       , // フォントの色を黒に設定
                        }}>=</Typography>
                  </Grid>
                {/* 答えのInputBox表示 */}
                  <Grid item xs={4} align="center">
                    <TextField 
                      variant="outlined"
                      size="small"
                      value={value}
                      onChange={handleChange}
                      autoFocus
                      onKeyDown={handleKeyPressResult} // Enterキーを押したときのイベントハンドラ
                      sx={{
                        fontFamily: 'DotGothic16',
                        fontSize: "25px",
                        color: '#000000',
                      }}/>
                  </Grid>

                {/* メッセージ欄表示 */}
                <Grid 
                  item xs={12} 
                  align="center"
                  sx={{
                    border       : '3px solid #696969', // 枠線の太さと色を設定
                    borderRadius : '5px'           , // 角丸の半径を設定
                    padding      : '0 5px'         , // 上下0px、左右20pxの余白を設定
                    top          : '200px'         , // 縦位置を指定
                    left         : '5px'           , // 横位置を指定
                    position     : 'absolute'      , // 絶対位置指定
                    width        : '96%'           , // 外枠の幅を指定
                    height       : '23%'           , // 外枠の高さを指定
                    }}>

                    <Typography
                      sx={{
                        // 独自フォントに設定
                        fontFamily   : 'DotGothic16'   , // フォント
                        fontSize     : "14px"          , 
                        color        : '#000000'       , // フォントの色を黒に設定
                        }}
                      onKeyDown={handleKeyPress} // Enterキーを押したときのイベントハンドラ
                      tabIndex={0} // キーボードフォーカス可能にする
                      >{pokemonname} があらわれた！<br/>
                      <span style={{ color: fontColor, fontSize: '20px' }}>{resultWord}</span></Typography>
                </Grid>
            </Grid>
        </Paper>
    <Grid container spacing={2}>
        <Grid item xs={12} align="center"></Grid>
    </Grid>
    </Box>
  );
}

export default GameMain;
